import { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { isEventsSpace } from "@/react/helpers/spaceHelpers";
import { newSpaceEventPath, posts } from "@/react/helpers/urlHelpers";
import { useNotificationDropdown } from "@circle-react/components/Spaces/SidebarV2/PlatformMenu/useNotificationDropdown";
import { usePlatformMenu } from "@circle-react/components/Spaces/SidebarV2/PlatformMenu/usePlatformMenu";
import { useSpacesContext } from "@circle-react/contexts";
import { useChatNotification } from "@circle-react/hooks/chatsV2/useChatNotification";
import { useShouldShowMessagingRoutes } from "@circle-react/hooks/useIsMessagingEnabled";

interface RouteParams {
  spaceSlug: string;
}

export const useBottomBar = () => {
  const isHomePage = useRouteMatch("/home")?.isExact;
  const isFeedPage = useRouteMatch("/feed")?.isExact;
  const routeMatch = useRouteMatch<RouteParams>("/c/:spaceSlug");
  const spaceSlug = routeMatch?.params?.spaceSlug || "";
  const space = useSpacesContext().helpers.findBy({ slug: spaceSlug });
  const isSpaceEvent = isEventsSpace(space);
  const [newPostUrl, setNewPostUrl] = useState("");
  const [shouldNewPostUseDataRemote, setShouldNewPostUseDataRemote] =
    useState(false);

  const { spotlightSearch } = usePlatformMenu();
  const { shouldShowMessagingRoutes } = useShouldShowMessagingRoutes();
  const {
    newNotificationCount,
    toggleNotificationDrawer,
    resetNewNotificationsCount,
  } = useNotificationDropdown();

  const { unreadChatCount } = useChatNotification();

  const onSearchClick = () => {
    void spotlightSearch.show();
  };

  const onNotificationsClick = () => {
    toggleNotificationDrawer();
    resetNewNotificationsCount();
  };

  useEffect(() => {
    let url;

    if (isHomePage || isFeedPage || !spaceSlug) {
      url = "/c/new_post_in_space";
      setShouldNewPostUseDataRemote(true);
    } else {
      url = isSpaceEvent
        ? newSpaceEventPath({ spaceSlug: space?.slug || "" })
        : posts.new({ spaceSlug: space?.slug || "" });
      setShouldNewPostUseDataRemote(false);
    }

    setNewPostUrl(url);
  }, [isHomePage, space?.slug, isSpaceEvent, isFeedPage, spaceSlug]);

  return {
    newPostUrl,
    shouldNewPostUseDataRemote,
    shouldNewPostOpenModal: !isSpaceEvent,
    unreadChatCount,
    unreadNotificationCount: newNotificationCount,
    onNotificationsClick,
    onSearchClick,
    shouldShowMessagingRoutes,
  };
};
